module.exports = __webpack_public_path__ + "img/d3ffcf3.jpg";